export type OwnProps = {
  error?: Error;
  componentStack?: string;
  statusCode?: number;
};

const ErrorBoundaryFallbackComponent = ({ statusCode }: OwnProps) => (
  <div className="min-h-[50vh] text-center">
    <p className="pt-48 text-4xl font-bold">Oops! {statusCode}</p>
    <p className="mt-8">There may have been a problem.</p>
    <p>We are sorry for the inconvenience.</p>

    <div>
      <img
        className="mx-auto my-56 h-[118px] w-[118px]"
        src="https://assets.fastly.carvana.io/merchui/images/error-sadcar-device.png"
        alt="Sad car"
      />
    </div>

    <a
      href="/cars"
      className="font-bold text-blue-2 no-underline"
      data-analytics-id="Error Boundary - Back to Search"
    >
      Get back to SEARCH
    </a>
  </div>
);

export default ErrorBoundaryFallbackComponent;
